<div id="modal-content-wrapper">
    <section class="modal-body">
        <p i18n  class="text" >
            Do you want to reserve a spot for <span class="bold">{{session.title}}</span> at <span class="bold">{{session.date | date:'yyyy-MM-dd HH:mm'}}</span>
        </p>
    </section>
    <footer id="modal-footer">
        <button i18n mat-raised-button id="modal-action-button" mat-dialog-close="success">
            Yes
        </button>
        <button i18n mat-raised-button id="modal-cancel-button" (click)="closeModal()">
            Cancel
        </button>
    </footer>
</div>